import { CountryPhoneInputValue } from 'antd-country-phone-input'
import { Overwrite, Required } from 'utility-types'
import { DdotSubmissionProps } from '@commutifi/models/DdotSubmission'
import { TDMStrategyProps } from '@commutifi/models/TDMStrategies'
import { GetResponse } from '@commutifi-fe/interfaces'
import { RequestParams } from 'shared/interfaces'
import { apiCall, dashboardApiServer, JSON_HEADER } from '../../index'
import endpoints from './endpoints'

export type { TDMStrategyProps }

const apiDashboardServer = apiCall(dashboardApiServer)

export interface Submission
  extends Overwrite<
    DdotSubmissionProps,
    {
      enterpriseProfile?: {
        incentives?: string[]
        contactName?: string
        businessName?: string
        contactEmail?: string
        contactTitle?: string
        DCemployeeCount?: number
        businessAddress?: {
          city?: string
          street?: string
          streetNumber?: string
          state?: string
          country?: string
          postalCode?: string
          officeId?: string
        }
        contactPhoneNumber?: CountryPhoneInputValue
        dcBusinessTaxIdNumber?: string | number
        nationwideEmployeeCount?: number
        dcBusinessTaxIdNumberType?: string
        howNotifiedAboutCompliance?: string[]
      }
    }
  > {
  id: string
}

export const fetchDDOTSubmissions = (
  queryParams: RequestParams & Partial<Submission>
): Promise<GetResponse<Submission>> =>
  apiDashboardServer(endpoints.GET.Submissions.path, {
    method: 'get',
    queryParams
  })

export const fetchEnterpriseEin = (submissionTaxId: string, queryParams?: RequestParams): Promise<null> =>
  apiDashboardServer(endpoints.GET.EnterprisesEin.route(submissionTaxId), {
    method: 'get',
    queryParams
  })

export const fetchTDMStrategies = (
  queryParams: RequestParams & Partial<TDMStrategyProps>
): Promise<GetResponse<TDMStrategyProps>> =>
  apiDashboardServer(endpoints.GET.TDMStrategies.path, {
    method: 'get',
    queryParams
  })

/*
 * POST METHODS
 */
export const postSubmission = (
  body: Required<Omit<Submission, 'id'>, 'enterpriseId' | 'enterpriseProfile'>
): Promise<Submission> =>
  apiDashboardServer(endpoints.POST.Submission.path, {
    method: 'post',
    headers: JSON_HEADER,
    data: JSON.stringify(body)
  })

/*
 * UPDATE METHODS
 */
export const patchSubmission = (
  submissionId: string,
  data: Partial<Omit<Submission, 'id'>>,
  // Save will not affect the status of the submission and submit will change the status based on complianceAnswers presence
  submissionType: 'save' | 'submit'
): Promise<Submission> =>
  apiDashboardServer(endpoints.PATCH.Submission.route(submissionId), {
    method: 'patch',
    headers: JSON_HEADER,
    queryParams: { submissionType },
    data
  })
